import React from "react";
import {
  Row,
  Col,
} from "reactstrap";
import SandSlider from "../../../components/SandSlider/SandSlider";

export const SlidersContainer = ({
  inventoryItems,
  onChangeSlider,
  params: {
    materials,
  }
}) => (
  <Col xs={12} md={10} style={{ margin: "auto" }}>
    <Row>
      {
        inventoryItems.map(({ id, code, name }) => {
          const material = materials.find(({ materialCode }) => materialCode === code);
          if (material) {
            return (
              <Col md={6} key={id}>
                <SandSlider
                  value={(material.humidity * 100).toFixed(1)}
                  onChangeSlider={(value) => onChangeSlider(code, value)}
                  title={`Umidade ${name}`}
                  sandClass="slider-container"
                  sandName="humidityThinSand"
                />
              </Col>
            );
          }
        })
      }
    </Row>
  </Col>
);
